import { Suspense } from "react";
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './containers/App/App';
import * as serviceWorker from './utils/serviceWorker';
import store from './utils/store';
import AppProvider from './containers/AppProvider/AppProvider';

import 'react-app-polyfill/stable';
import 'core-js/stable'
import './utils/i18n';

if (process.env.NODE_ENV !== 'development') {
  console.log = () => { };
}

const MOUNT_NODE = document.getElementById('root');
const root = createRoot(MOUNT_NODE);

root.render(
  <Provider store={store}>
    <Suspense fallback="...">
      <AppProvider>
        <App />
      </AppProvider>
    </Suspense>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();